import { FullScreenLoader } from "@repo/app-shell"
import { authClient } from "@repo/db"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"

export const Route = createFileRoute("/logout")({
  component: Logout,
})

function Logout() {
  const navigate = useNavigate()

  // EXCEPTION TO USEEFFECT RULE:
  // Side-effect must run once after mount so that the authenticated component
  // tree (and all its Convex subscriptions) has already been unmounted before
  // we invalidate the session.
  useEffect(() => {
    void authClient.signOut().then(() => {
      void navigate({ to: "/login", search: { redirect: undefined } })
    })
  }, [navigate])

  return <FullScreenLoader />
}
